/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  Primary entry point for transmitting data to endpoints
 */
/* --!!!!!ATTENTION!!!!!----- DO NOT DELETE code inside Webpack Macros, it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { ModuleManager , globalEngine } from "./Init";
import { dataManipulator } from "./common";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
function EventTransmitterTemplate() {
};


EventTransmitterTemplate.prototype =
    {
        "addDataSetNames": function (outbound, emitter, dataSetNames) {
            var allDataSetNames = [];
            if (emitter.dataSetNames) {
                allDataSetNames = allDataSetNames.concat(emitter.dataSetNames);
            }

            if (dataSetNames) {
                allDataSetNames = allDataSetNames.concat(dataSetNames);
            }
            // remove duplicates (could happen if the event and profile configs specify the same one)
            allDataSetNames = dataManipulator.arrayRemoveDuplicates(allDataSetNames);
            logDebug('emitter ProfileName: ' + emitter.profileName + '. allDataSetNames: ' + JSON.stringify(allDataSetNames));
            this._mergeDataSets(outbound, allDataSetNames);
        },
        "_isEventThrottled": function (messageName) {
            var priorityConfig = ModuleManager.getSingleton("priority_config");
            var eventManager = ModuleManager.getSingleton("config_manager");
            var eventThrottleThreshold = priorityConfig.getThreshold("eventThrottle");
            var eventPriority = eventManager.getPriority(messageName);
            if (eventPriority < eventThrottleThreshold) {
                var throttleRule = eventManager.getThrottleRule(messageName);
                return this._applyThrottle(messageName, throttleRule);
            }
            return false;
        },
        "_isProfileThrottled": function (messageName, profileName) {
            var priorityConfig = ModuleManager.getSingleton("priority_config");
            var eventManager = ModuleManager.getSingleton("config_manager");
            var profileThrottleThreshold = priorityConfig.getThreshold("profileThrottle");
            var eventPriority = eventManager.getPriority(messageName);
            if (eventPriority < profileThrottleThreshold) {
                var throttleRule = this._getProfile(profileName).throttleRule;
                return this._applyThrottle(profileName, throttleRule);
            }
            return false;
        },
        "_applyThrottle": function (name, rule) {
            try {
                if (!rule) {
                    return false;
                }
                var rules = ModuleManager.getSingleton("rules");
                return rules.evaluate(name, rule);
            }
            catch (e) {
                logError('_applyThrottle: ' + e.message);
            }

            // on error, exception, just assume it's not throttled, and execute the rest of the code as is
            return false;
        },
        "_applyAttributeRules": function (message, messageName, profileName) {
            try {
                var eventConfigManager = ModuleManager.getSingleton("config_manager");
                var attributeRules = eventConfigManager.getAttributeRules(messageName);
                if (!attributeRules) {
                    return message;
                }

                // deep copy the attribute rules and then map them
                var mappedRules = {};
                dataManipulator.mergeDictionary(mappedRules, attributeRules);

                // normalizing the rules to post global mappings and then apply the rules after normalization
                // message should already be normalized prior to reaching here
                var mappings = ModuleManager.getSingleton("mappings");
                mappedRules = mappings.eventMap(mappedRules, messageName);
                mappedRules = mappings.globalMap(mappedRules);
                mappedRules = mappings.toLowerCase(mappedRules, true, false);

                var rules = ModuleManager.getSingleton("rules");

                // Hit.UniqueID was reference incorrectly as message.Hit.UniqueID and fixed recently, broken between 02/24 - 04/03
                var defaults = ['uniqueid',
                    'hit.uniqueid',
                    'event.category',
                    'event.action',
                    'tracker.type',
                    '__transport.name',
                    '__record.created',
                    '__caller.name'];

                defaults = defaults.concat(this._getProfileDefaultAttributes(profileName));

                var cleanMessage = {}; // Variable to contain cleansed data

                // ignoring strict attribute rule implementation for profile_csis_ga
                if (this._getProfile(profileName)["ignoreAttributeRules"] == true) {
                    //fixed shallow copy object to deepcopy
                    //For error/automation logging, it should be a deepcopy
                    cleanMessage = JSON.parse(JSON.stringify(message));

                } else {
                    // Create a new object (cleanMessage) that includes default and rule defined items only
                    for (var ruleIndex in message) {
                        // check if attribute is default
                        var isDefault = false;
                        for (var idx in defaults) {
                            if (ruleIndex == defaults[idx]) {
                                isDefault = true;
                                break;
                            }
                        }

                        if (isDefault || mappedRules.hasOwnProperty(ruleIndex)) {
                            cleanMessage[ruleIndex] = message[ruleIndex];
                        }
                        // Ignoring attributes that starts with __ (sdk added metadata)
                        // assuming none of the attributes in the portal starts with __ (which is true at this time)
                        else if (ruleIndex.substring(0, 2) != "__") {
                            cleanMessage[ruleIndex] = "[ruleMismatch]";
                        }
                    }
                }

                logInformation("cleanMessage: " + JSON.stringify(cleanMessage));

                // Apply event rules
                for (var ruleIndex in mappedRules) {
                    var rule = mappedRules[ruleIndex];
                    if (rule.optional && (cleanMessage[ruleIndex] == null)) {
                        logInformation('_applyAttributeRules: optional field ' + ruleIndex + ' was skipped');
                        continue;
                    }

                    cleanMessage[ruleIndex] = rules.apply(cleanMessage[ruleIndex], rule);;

                }
                return  cleanMessage ;
            }
            catch (e) {
                logError('Exception thrown while calling _applyAttributeRules: ' + e.message);
            }
            return { "message": {} };
        },
        "_getProfileDefaultAttributes": function (profileName) {
            var defaults = [];
            if (profileName.indexOf("da") >= 0) {
                defaults.push('hit.trigger', 'hit.feature');
            }
            return defaults;
        },

        "_getProfile": function (name) {
            try {
                var transportProfiles = ModuleManager.getSingleton("transport_config");
                var transportProfile = transportProfiles[name];
                if (!transportProfile) {
                    logError("No such profile: '" + name + "'");
                }
                return transportProfile;
            }
            catch (e) {
                logError("Failed to locate profile '" + name + "': exception is '" + e.message + "'");
            }
        },
        "_mergeDataSets": function (outbound, dataSetNames) {
            if (!dataSetNames) {
                return; // nothing to merge
            }

            logDebug("merge data sets: " + JSON.stringify(dataSetNames));
            var dataSetManager = ModuleManager.getSingleton("dataset");
            for (var index in dataSetNames) {
                var datasetName = dataSetNames[index];
                try {
                    var dataset = dataSetManager.get(datasetName);
                    if (!dataset) {
                        logWarning("Could not find dataset '" + datasetName + "'; skipping");
                        continue; // try another
                    }
                    logDebug("merge the '" + datasetName + "' dataset");
                    dataManipulator.mergeAndLowerDictionary(outbound, dataset.getContent());
                }
                catch (e) {
                    logError("Failed to apply DataSet '" + datasetName + "': exception is '" + e.message + "'");
                }
            }
        },
        "retrieveEmitter": function (profileName) {
            var emitter = this._getEmitter(profileName);
            if (!emitter) {
                return this._addEmitter(profileName);
            }
            return emitter;
        },
        "_getEmitter": function (profileName) {
            return this._emitters[profileName];
        },
        "_addEmitter": function (profileName) {
            var profile = this._getProfile(profileName);
            if (!profile) {
                return null;
            }

            logDebug("configure the emitter (" + profileName + ")");
            //emitter.configure(profileName, profile);
            var emitter = ModuleManager.create("emitter");
            emitter.configure(profileName, profile);
            this._emitters[profileName] = emitter;
            return this._emitters[profileName];
        },
        "_emitters": {}
    };


ModuleManager.registerFactory("transmitter_template", EventTransmitterTemplate);
//export  {EventTransmitterTemplate};
//globalEngine.FactoryMap["transmitter_template"] =  EventTransmitterTemplate;
